// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideIn {
    0% {
        right: -200%;
    }
    100% {
        right: 0;
    }
}

@keyframes appearFromMiddle {
    0% {
        opacity: 0;
        transform: translate(0%, -10%);
    }
    100% {
        opacity: 1;
        transform: translate(0%, 0%);
    }
}
  

/* Main */
.main-box {
    padding: 10px 20px 20px 20px;
    border-radius: 4px;
}

.outline-box {
    margin: 15px 5px 5px 20px;
}

.main-divider {
    margin: 25px 5px !important;
}


/* Edit Tab */
#edit-box {
    animation: slideIn 0.5s ease forwards;
}

#scroll-filter {
    display:'flex'; 
    margin-bottom: 1rem;
    white-space: nowrap;
    object-fit: contain;  
    overflow-x: auto;
}

#edit-box.reverse {
    animation: slideIn 0.5s ease reverse forwards;
}

.tab-button {
    border-bottom: solid 2px transparent;
    
}

.tab-grid {
    margin: 0 15px;
}


/* Login Page */
#login-box {
    animation: appearFromMiddle 1s forwards;
}

/* Main-text-Field */

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}

/* Kanban */

.scrollable-element  {
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: 2px;
    scroll-behavior: smooth;
    height: 535px;  
}

.scrollable-element::-webkit-scrollbar {
    width: 5px;
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;IAChB;IACA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,4BAA4B;IAChC;AACJ;;;AAGA,SAAS;AACT;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA,aAAa;AACb;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,cAAc;AAClB;;;AAGA,eAAe;AACf;IACI,uCAAuC;AAC3C;;AAEA,oBAAoB;;AAEpB;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd","sourcesContent":["@keyframes slideIn {\n    0% {\n        right: -200%;\n    }\n    100% {\n        right: 0;\n    }\n}\n\n@keyframes appearFromMiddle {\n    0% {\n        opacity: 0;\n        transform: translate(0%, -10%);\n    }\n    100% {\n        opacity: 1;\n        transform: translate(0%, 0%);\n    }\n}\n  \n\n/* Main */\n.main-box {\n    padding: 10px 20px 20px 20px;\n    border-radius: 4px;\n}\n\n.outline-box {\n    margin: 15px 5px 5px 20px;\n}\n\n.main-divider {\n    margin: 25px 5px !important;\n}\n\n\n/* Edit Tab */\n#edit-box {\n    animation: slideIn 0.5s ease forwards;\n}\n\n#scroll-filter {\n    display:'flex'; \n    margin-bottom: 1rem;\n    white-space: nowrap;\n    object-fit: contain;  \n    overflow-x: auto;\n}\n\n#edit-box.reverse {\n    animation: slideIn 0.5s ease reverse forwards;\n}\n\n.tab-button {\n    border-bottom: solid 2px transparent;\n    \n}\n\n.tab-grid {\n    margin: 0 15px;\n}\n\n\n/* Login Page */\n#login-box {\n    animation: appearFromMiddle 1s forwards;\n}\n\n/* Main-text-Field */\n\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n  -webkit-appearance: none; \n  margin: 0; \n}\n\n/* Kanban */\n\n.scrollable-element  {\n    overflow-y: scroll;\n    -ms-overflow-style: none;\n    scrollbar-width: 2px;\n    scroll-behavior: smooth;\n    height: 535px;  \n}\n\n.scrollable-element::-webkit-scrollbar {\n    width: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
